import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { MixpanelEvent } from 'src/app/shared/model/mix-panel-event.enum';
import { MixpanelService } from 'src/app/shared/service/mix-panel.service';

@Component({
  selector: 'app-creatics-about',
  templateUrl: './creatics-about.component.html',
  styleUrls: ['./creatics-about.component.css']
})
export class CreaticsAboutComponent implements OnInit {
  aboutpage: any
  videoUrl: any
  mainUrl : any
  userLoggedIn = false
  bannerButton: any;
  bannerUrl: any;
  bannerImage: any;
  bannerText: any;
  description: any;
  eventMainHeading: any;
  creaticsSubject: any;
  posterImage: any;
  creaticsContents: any;
  creaticsLists: any;
  fanCreatorImg1: any;
  fanCreatorImg2: any;

  constructor(
    private service: AdminService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private spinner : NgxSpinnerService,
    private mixpanelService:MixpanelService
  ) { }

  ngOnInit(): void {
    this.service.getCreaticsAboutpage().subscribe(data => {
      this.aboutpage = data.creaticsAboutPage

      this.bannerButton = this.aboutpage.bannerButton
      this.bannerUrl = this.aboutpage.bannerUrl
      this.bannerImage = this.getFileNameFromUrl(this.aboutpage.bannerImage); 
      this.bannerText = this.aboutpage.bannerText
      this.videoUrl = this.aboutpage.videoUrl
      this.description = this.aboutpage.description
      this.eventMainHeading = this.aboutpage.eventMainHeading
      this.creaticsSubject = this.aboutpage.creaticsSubject
      this.posterImage = this.getFileNameFromUrl(this.aboutpage.videoThumbnail)
      this.fanCreatorImg1 = this.getFileNameFromUrl(this.aboutpage.fanCreatorImg1)
      this.fanCreatorImg2 = this.getFileNameFromUrl(this.aboutpage.fanCreatorImg2)

      this.creaticsContents = this.aboutpage.creaticsContents
      this.creaticsLists = this.aboutpage.creaticsLists

      if(data.userId>0){
        this.userLoggedIn = true
      }
      else{
        this.userLoggedIn = false
      }

      var url = this.aboutpage.mainUrl

      if(url != null  && url !== ''){
        this.mainUrl=true
      }
      else{
        this.mainUrl = false
      }
    })
  }
loadVideo(){
  const myvid = document.getElementById('videoBG') as HTMLMediaElement;
  myvid.load()
}
getFileNameFromUrl(url: string): string {
  const filename = url.split('amazonaws.com/')[1];
  return 'https://dmle451e1wlcf.cloudfront.net/'+filename
}
onPlay(){
  this.mixpanelService.trackEvent({
    event:MixpanelEvent.BUTTON_CLICKED,
    properties:{
      title:"about_creatics_video_played",
      feature_context: 'ABOUT_CREATICS'
    }
  })
}

}
